module.exports = "<div class=\"page-grocery-detail grocery gallery\">\r\n    <sku-info></sku-info>\r\n    <brand-info></brand-info>\r\n    <spec-info></spec-info>\r\n    <dimension-table></dimension-table>\r\n    <feature-list></feature-list>\r\n    <scene-list></scene-list>\r\n    <maintain-info></maintain-info>\r\n    <knowledge-info></knowledge-info>\r\n    <more-products></more-products>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/page/gallery-page-content.html
// module id = 321
// module chunks = 0